<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add mb-1">
      <b-col cols="12" md="5" xl="4">
        <b-form-checkbox
          v-model="reportSearchSection"
          @change="
            () => (this.showReportSearchSection = !this.showReportSearchSection)
          "
          ><b>show section</b></b-form-checkbox
        >
      </b-col>
    </b-row>

    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->

      <b-col
        v-if="reportSearchSection"
        cols="12"
        md="5"
        xl="4"
        class="invoice-actions"
      >
        <!-- Action Buttons -->

        <b-card>
          <!-- <b-tabs justified>
            <b-tab @click="onTabChange" title="Single"> -->
          <b-form-group label="Report Type">
            <b-form-radio-group
              @change="onReportChange"
              id="radio-group-3"
              v-model="filters.reportType"
              name="radio-sub"
            >
              <b-form-radio name="some-radios1" value="default"
                >Default Report</b-form-radio
              >
              <b-form-radio name="some-radios1" value="territory"
                >Report With Territory
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <b-form-group label="Show Report By" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              @change="onOrderChange"
              id="radio-group-2"
              v-model="filters.showReportBy"
              :aria-describedby="ariaDescribedby"
              name="radio-sub-component"
            >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="vendor"
                >Licensor</b-form-radio
              >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="movie"
                >Movie</b-form-radio
              >
            </b-form-radio-group>
          </b-form-group>
          <b-form-group label="Report View" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              @change="onChange"
              id="rightsView"
              v-model="filters.reportView"
              :aria-describedby="ariaDescribedby"
              name="radio-sub-rightsView"
            >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="some-rights"
                value="rights"
                >Type 1(Grouped Rights)</b-form-radio
              >
              <b-form-radio
                :aria-describedby="ariaDescribedby"
                name="some-subRights"
                value="subRights"
                >Type 2 (Ungrouped-Rights)</b-form-radio
              >
            </b-form-radio-group>
          </b-form-group>
          <div v-if="filters.showReportBy == 'vendor'">
            <b-form-group label="Licensor">
              <v-select
                @input="getLicensorMovies('no')"
                v-model="filters.licensor"
                placeholder="Licensor"
                label="company"
                :options="optionVendors"
                :loading="isVendorLoading"
                class="borderRadius-10"
              />
            </b-form-group>
            <b-form-group label="Movie">
              <v-select
                @input="onChange"
                v-model="filters.movie"
                placeholder="Movie"
                label="multi_movies"
                :loading="isMovieLoading"
                :options="optionMultipleMovies"
                class="borderRadius-10"
              />
            </b-form-group>
          </div>
          <div v-else>
            <b-form-group label="Movie">
              <v-select
                @input="getMoviesLicensor"
                v-model="filters.movie"
                placeholder="Movie"
                label="full_title"
                :options="optionMovies"
                :loading="isMovieLoading"
                class="borderRadius-10"
              />
            </b-form-group>
            <b-form-group label="Licensor">
              <v-select
                @input="onChange"
                v-model="filters.licensor"
                placeholder="Licensor"
                label="company"
                :loading="isVendorLoading"
                :options="optionCustomer"
                class="borderRadius-10"
              />
            </b-form-group>
          </div>

          <b-form-group v-if="tabIndex == 0" label="Revenue Date Range">
            <flat-pickr
              @input="onChange"
              v-model="filters.revenueDate"
              placeholder="Revenue Date"
              class="form-control borderRadius-10"
              :config="{ mode: 'range', ...$flatPickrConfig }"
            />
          </b-form-group>
          <b-form-group
            v-if="
              tabIndex == 0 &&
              this.rights_tree.length &&
              filters.reportView == 'subRights'
            "
            label="Rights To Ungroup"
          >
            <master-treeselect
              v-model="report_rights"
              :options="rights_tree"
              multiple
              placeholder="Rights"
            />
          </b-form-group>
          <b-button
            v-if="tabIndex == 0"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            class="mb-75 borderRadius-10"
            block
            @click="getReportContracts"
            :disabled="
              (filters.licensor || filters.movie) &&
              filters.revenueDate &&
              filters.revenueDate.split('to').length == 2
                ? false
                : true
            "
          >
            Fetch Royalty Report
          </b-button>
          <!-- </b-tab>
            <b-tab @click="onTabChange" title="Multiple" lazy>
              <b-form-group label="Licensor">
                <v-select
                  @input="getLicensorMovies('yes')"
                  v-model="selectedCustomer"
                  placeholder="Licensor"
                  label="company"
                  :options="optionVendors"
                />
              </b-form-group>
              <b-form-group label="Movie">
                <v-select
                  v-model="selectedMovie"
                  placeholder="Movie"
                  label="multi_movies"
                  :options="optionMultipleMovies"
                />
              </b-form-group>

              <b-form-group label="Revenue Date Range">
                <flat-pickr
                  v-model="revenueDateRange"
                  placeholder="Revenue Date"
                  class="form-control"
                  :config="{ mode: 'range', ...$flatPickrConfig }"
                />
              </b-form-group>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                @click="getReportContracts"
                :disabled="
                  !selectedCustomer ||
                  !selectedMovie ||
                  !revenueDateRange ||
                  revenueDateRange.split('to').length < 2
                    ? true
                    : false
                    ? true
                    : false
                "
              >
                Generate Report
              </b-button>
            </b-tab>
          </b-tabs> -->

          <b-button
            v-if="tabIndex == 2 || tabIndex == 1"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            class="mb-75 borderRadius-10 buttonColor"
            block
            @click="searchSavedReports"
          >
            Search
          </b-button>

          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            block
            @click="resetForm"
            class="borderRadius-10"
          >
            Reset
          </b-button>

          <!-- Button: Print -->
        </b-card>

        <table
          style="background: whiteSmoke"
          v-if="royaltyReportData && tabIndex == 0"
        >
          <tr>
            <td class="text-wrap text-left">
              Deduction P&A From Cinematic Gross Receipts (Cost Off Top Deal)
            </td>
            <td>
              {{
                royaltyReportData.Deduction_from_Rental_PA[0] == "1"
                  ? "Yes"
                  : "No"
              }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Deduction MG From Cinematic Gross Receipts
            </td>
            <td>
              {{
                royaltyReportData.Deduction_from_Rental_MG[0] == "1"
                  ? "Yes"
                  : "No"
              }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Distributor Corridor Prior To Recoupement Of P&A
            </td>
            <td>
              {{
                royaltyReportData
                  .Distributor_Share_prior_to_recoupement_on_PA[0] == "1"
                  ? "Yes"
                  : "No"
              }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Distributor Corridor Prior To Recoupement of MG
            </td>
            <td>
              {{
                royaltyReportData
                  .Distributor_Share_prior_to_recoupement_on_MG[0] == "1"
                  ? "Yes"
                  : "No"
              }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Distributor Corridor Prior To Recoupement Of P&A and MG
            </td>
            <td>
              {{
                royaltyReportData.Distributor_Commission_on_Rental[0] == "1"
                  ? "Yes"
                  : "No"
              }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Licensor Corridor Prior To Recoupement Of P&A
            </td>
            <td>
              {{
                royaltyReportData
                  .Licensor_Share_prior_to_recoupement_on_PA[0] == "1"
                  ? "Yes"
                  : "No"
              }}
            </td>
          </tr>
          <tr>
            <td class="text-wrap text-left">
              Licensor Corridor Prior To Recoupement Of MG
            </td>
            <td>
              {{
                royaltyReportData
                  .Licensor_Share_prior_to_recoupement_on_MG[0] == "1"
                  ? "Yes"
                  : "No"
              }}
            </td>
          </tr>
        </table>
      </b-col>
      <b-col
        cols="12"
        :xl="reportSearchSection ? '8' : '12'"
        :md="reportSearchSection ? '7' : '12'"
      >
        <div>
          <b-tabs pills v-model="tabIndex" class="royalty-report-tabs"          
          >
            <b-tab title="Royalty Report" active>


              <!-- <b-row 
                style="
                  overflow-x: auto;
                  display: flex;
                  padding-top: 0.35rem;
                  padding-bottom: 0.35rem;
                  width: 100%;
                  margin: 0;
                "
              >
                <div 
                  class="d-flex flex-column" 
                  style="
                    width: 100%; 
                    min-width: max-content;
                  "
                >
                  <b
                  v-if="selectedRotaltyContracts.length > 1"
                  style="width:100%;"
                  >
                  Total:{{ selectedRotaltyContracts.length }}
                  </b>
                  <b-list-group
                    style="
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      gap: 1rem;
                      padding: 0.5rem 0;
                      margin: 0;
                      min-width: max-content;
                    "
                  >
                    <b-list-group-item
                      v-for="(item, index) in selectedRotaltyContracts"
                      :key="index"
                      :active="selectedContractID === item.contract_id"
                      @click="getRoyaltyReportMultiple(item)"
                      style="
                        min-width: 120px;
                        padding: 0.5rem;
                        border-radius: 0.5rem;
                        cursor: pointer;
                        flex-shrink: 0; 
                      "
                    >
                      <div style="">
                        <div style="font-size: 12px; font-weight: 300; font-family: verdana;">
                          Report {{ index + 1 }}
                        </div>
                        <div style="font-size: 12px; font-weight: 300; font-family: verdana;">
                          Contract Id: {{ item.contract_id }}
                        </div>
                          <div style="font-size: 12px; font-weight: 300; font-family: verdana;">
                          Movie Title: {{ formattedTitle(item.title) }}
                        </div>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </div>
              </b-row> -->
            
            <b-col cols="12" md="9">
              <b v-if="selectedRotaltyContracts.length > 1" style="width:100%;">
                Total: {{ selectedRotaltyContracts.length }}
              </b>
  
                <b-form-group
                    v-if="selectedRotaltyContracts.length > 1"
                    label="Royalty Reports"
                    label-for="royalty-report-select"
                  >
                    <v-select
                      v-if="selectedRotaltyContracts.length > 1"
                      id="royalty-report-select"
                      :options="selectedContractsOptions"
                      :get-option-label="getOptionLabel"
                      track-by="contract_id"
                      :reduce="item => item.contract_id"
                      v-model="selectedContractID"
                      @input="handleReportSelect"
                      @open="onReportSelectOpen"
                      @close="onReportSelectClose"
                      placeholder="Select Report"
                      ref="royaltySelect"
                    >
                      <template #option="option">
                        <div style="font-size: 12px; font-family: Verdana;">
                          <strong>Report {{ getReportIndex(option.contract_id) }}</strong><br />
                          Contract Id: {{ option.contract_id }}<br />
                          Movie Title: {{ formattedTitle(option.title) }}
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div v-if="!isReportSelectOpen" style="font-size: 12px; font-family: Verdana;">
                          <strong>Report {{ getReportIndex(option.contract_id) }}</strong><br />
                          Contract Id: {{ option.contract_id }}<br />
                          Movie Title: {{ formattedTitle(option.title) }}
                        </div>

                        <div v-else style="min-height: 1.6rem;"></div>
                      </template>
                    </v-select>
                  </b-form-group>

                  <b-button
                    class="my-1 mr-1"
                    variant="primary"
                    v-if="reportContractId"
                    @click="showRevenueExpensesModal = true"
                  >
                    Show Revenue/Expenses
                  </b-button>
                  <b-button
                    class="my-1"
                    variant="outline-primary"
                    v-if="royaltyReportData"
                    @click="showReportInfoModal = true"
                  >
                    Report Info
                  </b-button>
              </b-col>

              <b-alert show variant="dark " class="alert-heading px-10">
                <h4
                  v-if="royaltyReportData && royaltyReportData.statement_period"
                  class="alert-heading"
                >
                  <span>
                    <b
                      >Licensor :
                      {{ filters.licensor ? filters.licensor.company : "" }}<br
                    /></b>
                    <b
                      >Movie : {{ royaltyReportData.isMultipleMovies.toString()
                      }}<br
                    /></b>
                    <b
                      >Statement Period :
                      {{ royaltyReportData.statement_period }}</b
                    >
                  </span>
                </h4>

                <h4 v-else class="alert-heading">
                  For royalty report please provide required fields and click
                  generate report.
                </h4>

                <div
                  v-if="royaltyReportData && royaltyReportData.statement_period"
                >
                  <b-row class="m-1">
                    <b-col md="6">
                      <b-form-group label="sent to">
                        <b-form-input
                          id="event-description"
                          v-model="reportSentTo"
                          class="borderRadius-10"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        label="Comments"
                        label-for="event-description"
                      >
                        <b-form-textarea
                          id="event-description"
                          v-model="reportDescription"
                          class="borderRadius-10"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-alert>
              <div
                v-if="royaltyReportData && royaltyReportData.statement_period"
              >
                <table
                  class="report-table"
                  ref="rrt_table"
                  id="rrt_table"
                >
                  <thead class="bg-gray-200">
                    <tr>
                      <th class="px-1 text-left text-xs font-bold tracking-wider" style="width: 350px;">Theatrical</th>
                      <th class="px-1 tracking-wider" colspan="2"></th>
                      <th class="px-1 text-right text-xs font-bold tracking-wider">Admissions</th>
                      <th class="px-1 text-right text-xs font-bold tracking-wider">Box Office</th>
                      <th class="px-1 text-right text-xs font-bold tracking-wider">Rental</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="px-1 whitespace-nowrap text-left" colspan="3">Accumulated</td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <span>{{ royaltyReportData.accuAddmissionSum }} </span>
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <span
                          >
                          {{
                            formatCurrency(
                              Number(royaltyReportData.accuBoxOfficeSum)
                            )
                          }}
                        </span>
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <span
                          >
                          {{
                            formatCurrency(
                              Number(royaltyReportData.accuRentalSum)
                            )
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="px-1 whitespace-nowrap text-left" colspan="3">This Period</td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <span>{{ royaltyReportData.periodAddmissionSum }} </span>
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <span
                          >
                          {{
                            formatCurrency(
                              Number(royaltyReportData.periodBoxOfficeSum)
                            )
                          }}
                        </span>
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <span
                          >
                          {{
                            formatCurrency(
                              Number(royaltyReportData.periodRentalSum)
                            )
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr class="font-bold bg-gray-200">
                      <td class="px-1 whitespace-nowrap text-left" colspan="3">Total</td>
                      <td class="px-1 whitespace-nowrap text-right">{{ royaltyReportData.totalAddmissionSum }}</td>
                      <td class="px-1 whitespace-nowrap text-right">
                        {{
                          formatCurrency(
                            Number(royaltyReportData.totalBoxOfficeSum)
                          )
                        }}
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        {{
                          formatCurrency(Number(royaltyReportData.totalRentalSum))
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <tr>
                      <th class="px-1 text-left text-xs tracking-wider font-normal" colspan="3">P&A</th>
                      <th class="px-1 text-right text-xs tracking-wider font-normal">Accumulated</th>
                      <th class="px-1 text-right text-xs tracking-wider font-normal">This Period</th>
                      <th class="px-1 text-right text-xs tracking-wider font-normal">Total</th>
                    </tr>
                    <tr>
                      <td colspan="3"></td>
                      <td class="px-1 whitespace-nowrap text-right">{{formatCurrency(Number(royaltyReportData.accu_expense_amount))}}</td>
                      <td class="px-1 whitespace-nowrap text-right">{{formatCurrency(Number(royaltyReportData.period_expense_amount))}}</td>
                      <td class="px-1 whitespace-nowrap text-right">{{formatCurrency(Number(royaltyReportData.total_expense_amount))}}</td>
                    </tr>
                    <tr>
                      <td class="text-left px-1 whitespace-nowrap" colspan="5">MG</td>

                      <td class="px-1 whitespace-nowrap text-right">
                        {{ formatCurrency(Number(royaltyReportData.MG_PA)) }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        Number(
                          royaltyReportData.distributor_Share_prior_to_recoupement_new
                        ) > 0
                      "
                    >
                      <td class="text-left px-1 whitespace-nowrap" colspan="4">
                        Distributor Corridor Prior To Recoupement Of P&A
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          {{
                            royaltyReportData.distributor_Share_prior_to_recoupement_percent
                          }}
                          %
                        </p>
                      </td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.distributor_Share_prior_to_recoupement_new
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>

                    <tr
                      v-if="
                        Number(
                          royaltyReportData.Distributor_Share_prior_to_recoupement_on_MG_val
                        ) > 0
                      "
                    >
                      <td class="text-left px-1 whitespace-nowrap" colspan="4">
                        Distributor Corridor Prior To Recoupement Of MG
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          {{
                            royaltyReportData.Distributor_Share_prior_to_recoupement_on_MG_percent
                          }}
                          %
                        </p>
                      </td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.Distributor_Share_prior_to_recoupement_on_MG_val
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        Number(
                          royaltyReportData.Distributor_Commission_on_Rental_val
                        ) > 0
                      "
                    >
                      <td colspan="4" class="text-left px-1 whitespace-nowrap">
                        Distributor Corridor Prior To Recoupement Of P&A And MG
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          {{
                            royaltyReportData.Distributor_Commission_on_Rental_percent
                          }}
                          %
                        </p>
                      </td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.Distributor_Commission_on_Rental_val
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        Number(
                          royaltyReportData.Licensor_Share_prior_to_recoupement_on_PA_val
                        ) > 0
                      "
                    >
                      <td colspan="4" class="text-left px-1 whitespace-nowrap">
                        Licensor Corridor Prior To Recoupement Of P&A
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          {{
                            royaltyReportData.Licensor_Share_prior_to_recoupement_on_PA_percent
                          }}
                          %
                        </p>
                      </td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.Licensor_Share_prior_to_recoupement_on_PA_val
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        Number(
                          royaltyReportData.Licensor_Share_prior_to_recoupement_on_MG_val
                        ) > 0
                      "
                    >
                      <td colspan="4" class="text-left px-1 whitespace-nowrap">
                        Licensor Corridor Prior To Recoupement Of MG
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          {{
                            royaltyReportData.Licensor_Share_prior_to_recoupement_on_MG_percent
                          }}
                          %
                        </p>
                      </td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.Licensor_Share_prior_to_recoupement_on_MG_val
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-left px-1 whitespace-nowrap">Total</td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.allocation_torwards_pa_final
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-left px-1 whitespace-nowrap">
                        Cinematic Share Post Recoupment
                      </td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(royaltyReportData.theatrical_overages)
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <tr class="bg-gray-200">
                      <td colspan="4" class="text-left px-1 whitespace-nowrap font-bold">
                        Licensor's Share Of Overage
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          {{
                            royaltyReportData.Distributor_Theatrical_Share_percent
                          }}
                          %
                        </p>
                      </td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.Distributor_Theatrical_Share
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <template
                      v-for="(
                        itemMain, indexMain
                      ) in royaltyReportData.licensorArray"
                    >
                      <tr class="bg-gray-200" :key="`header-${indexMain}`">
                        <td class="px-1 text-left text-xs font-bold">
                          {{ royaltyReportData.movie_names[indexMain] }}
                        </td>
                        <td class="px-1 text-right text-xs font-bold tracking-wider">Accumulated </td>
                        <td class="px-1 text-right text-xs font-bold tracking-wider">This Period</td>
                        <td class="px-1 text-right text-xs font-bold tracking-wider">Total Revenue</td>
                        <td class="px-1 text-right text-xs font-bold tracking-wider">Share</td>
                        <td class="px-1 text-right text-xs font-bold tracking-wider">Licensor's Share</td>
                      </tr>
                      <tr
                        v-for="(item, index) in itemMain"
                        :key="`item-${indexMain}-${index}`"
                      >
                        <td class="text-left px-1 whitespace-nowrap"> {{ item.rightName }} <br />
                          <span class="text-muted">
                            <small class="text-muted">
                              {{
                                item.subrightsNamesString
                                  ? "( " + item.subrightsNamesString + " )"
                                  : ""
                              }}</small
                            >
                          </span>
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          {{
                            item.sumBilledAcc
                              ? formatCurrency(Number(item.sumBilledAcc))
                              : "0.00"
                          }}
                        </td>
                        <td class="px-1 whitespace-nowrap text-right font-bold">
                          {{
                            item.sumBilledPeriod
                              ? formatCurrency(Number(item.sumBilledPeriod))
                              : "0.00"
                          }}
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          {{
                            item.sumBilledTotal
                              ? formatCurrency(Number(item.sumBilledTotal))
                              : "0.00"
                          }}
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          {{ item.rightPercent ? item.rightPercent : "0" }}
                          %
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">
                          {{
                            item.totalFinal
                              ? formatCurrency(Number(item.totalFinal))
                              : "0.00"
                          }}
                        </td>
                      </tr>
                      <tr
                        v-for="(
                          itemNew, indexNew
                        ) in royaltyReportData.miscellaneous_revenue_array"
                        :key="`misc-${indexMain}-${indexNew}`"
                      >
                        <td class="px-1 whitespace-nowrap text-left" colspan="4">
                          {{ itemNew.name }}
                        </td>
                        <td class="px-1 whitespace-nowrap text-right">100 %</td>
                        <td class="px-1 whitespace-nowrap text-right">
                          {{ formatCurrency(itemNew.amount) }}
                        </td>
                      </tr>
                    </template>

                    <!-- <tr>
                      <td colspan="5">
                        LICENSOR CORRIDOR PRIOR TO RECOUPEMENT OF MG
                      </td>

                      <td>
                        <p>
                          <b>
                            CHF
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.Licensor_Share_prior_to_recoupement_on_MG_val
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr> -->
                    <tr>
                      <th colspan="5" class="text-left px-1 whitespace-nowrap font-bold">Total Licensor Share</th>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b
                            >
                            {{
                              formatCurrency(royaltyReportData.liencer_sum1)
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <!-- <tr>
                      <td colspan="5">
                        LICENSOR CORRIDOR PRIOR TO RECOUPEMENT OF P&A
                      </td>

                      <td>
                        <p>
                          <b>
                            CHF
                            {{
                              formatCurrency(
                                Number(
                                  royaltyReportData.Licensor_Share_prior_to_recoupement_on_PA_val
                                )
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr> -->

                    <tr class="font-bold bg-gray-200">
                      <th colspan="5" class="text-left px-1 whitespace-nowrap">
                        Total With Licensor Corridor Prior To Recoupment
                      </th>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                royaltyReportData.Total_with_Licensor_Corridor_prior_to_recoupment
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <tr>
                      <th colspan="6" class="text-left font-bold px-1 whitespace-nowrap">Already Paid</th>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-left px-1 whitespace-nowrap">MG</td>
                      <td class="px-1 whitespace-nowrap text-right">
                        {{
                          formatCurrency(
                            Number(royaltyReportData.Already_paid_MG)
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-left px-1 whitespace-nowrap">Bumper Paid</td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(royaltyReportData.BUMPER_PAID)
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-left px-1 whitespace-nowrap">Overage Paid</td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(royaltyReportData.OVERAGES_PAID)
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-left px-1 whitespace-nowrap">Divers Paid</td>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(royaltyReportData.DIVERS_PAID)
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr
                      v-for="(
                        itemM, indexM
                      ) in royaltyReportData.new_revenue_types_array"
                      :key="indexM"
                    >
                      <td colspan="5" class="text-left px-1 whitespace-nowrap">{{ itemM.name }}</td>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{ formatCurrency(Number(itemM.amount)) }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr class="bg-gray-200 font-bold">
                      <th colspan="5" class="text-left px-1 whitespace-nowrap">
                        {{
                          royaltyReportData.Balance_to_your_favor &&
                          Number(royaltyReportData.Balance_to_your_favor) < 0
                            ? "Unrecouped"
                            : "Balance To Your Favour"
                        }}
                      </th>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(royaltyReportData.Balance_to_your_favor)
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <tr v-if="royaltyReportData.showCoridorSection == true">
                      <th class="text-left px-1 whitespace-nowrap" colspan="6">
                        Licensor Share Of Corridor
                      </th>
                    </tr>

                    <tr v-if="royaltyReportData.showCoridorSection == true">
                      <td class="text-left px-1 whitespace-nowrap" colspan="5">
                        Licensor Share Prior To Recoupement On P&A
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        {{
                          formatCurrency(
                            Number(
                              royaltyReportData.Licensor_Share_prior_to_recoupement_on_PA_val
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr v-if="royaltyReportData.showCoridorSection == true">
                      <td class="text-left px-1 whitespace-nowrap" colspan="5">
                        Licensor Share Prior To Recoupement On MG
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        {{
                          formatCurrency(
                            Number(
                              royaltyReportData.Licensor_Share_prior_to_recoupement_on_MG_val
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr v-if="royaltyReportData.showCoridorSection == true" class="font-bold bg-gray-200">
                      <th class="text-left px-1 whitespace-nowrap" colspan="5">
                        Total Licensor Corridor
                      </th>
                      <th class="px-1 whitespace-nowrap text-right">
                        {{
                          formatCurrency(
                            Number(
                              parseFloat(
                                royaltyReportData.Licensor_Share_prior_to_recoupement_on_PA_val
                              ) +
                                parseFloat(
                                  royaltyReportData.Licensor_Share_prior_to_recoupement_on_MG_val
                                )
                            )
                          )
                        }}
                      </th>
                    </tr>
                    <tr v-if="royaltyReportData.showCoridorSection == true">
                      <td class="text-left px-1 whitespace-nowrap" colspan="5">
                        Less Licensor Corridor Paid
                      </td>
                      <td class="px-1 whitespace-nowrap text-right">
                        {{
                          formatCurrency(
                            Number(royaltyReportData.Less_Licensor_corridor_Paid)
                          )
                        }}
                      </td>
                    </tr>
                    <tr v-if="royaltyReportData.showCoridorSection == true" class="font-bold bg-gray-200">
                      <th class="text-left px-1 whitespace-nowrap" colspan="5">Balance Payable</th>

                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(royaltyReportData.Balance_payable)
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th class="px-1 py-1" colspan="6"></th>
                    </tr>
                    <tr v-if="royaltyReportData.showCoridorSection == true" class="font-bold bg-gray-200">
                      <th class="text-left px-1 whitespace-nowrap" colspan="5">Total Payable</th>
                      <td class="px-1 whitespace-nowrap text-right">
                        <p>
                          <b>
                            {{
                              formatCurrency(
                                Number(royaltyReportData.total_payable)
                              )
                            }}</b
                          >
                        </p>
                      </td>
                    </tr>
                  </tbody>

                  <!-- <tr class="spacing">
                    <th class="text-center" colspan="6">
                    
                    </th>
                  </tr> -->
                </table>

                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  class="m-2"
                >
                  <b-button
                    :disabled="loading ? true : false"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="gradient-primary"
                    class="ml-2 borderRadius-10"
                    @click="showGenerateConfirm(royaltyReportData)"
                  >
                    <b-spinner v-if="loading" small /> Generate Royalty Report
                  </b-button>
                </div>
                <b-row> </b-row>
              </div>
            </b-tab>
            <b-tab title="Existing Royalty Reports">
              <b-alert variant="secondary" show>
                <b-row cols="12" class="mb-1 alert-heading">
                  <b-col
                    class="d-flex align-items-center justify-content-between"
                  >
                    <b-form-radio-group
                      @change="GetSavedReports"
                      id="radio-group-1"
                      v-model="selectedRadio"
                      :options="optionsRadio"
                      name="radio-options"
                    ></b-form-radio-group>
                    <div class="scroll-buttons" >
                      <b-button
                        v-b-tooltip.hover.v-primary.top="buttonTooltip"
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        class="btn-icon rounded-circle dynamic-scroll-button"
                        @click="handleScrollClick"
                      >
                        <feather-icon :icon="buttonIcon" size="14" />
                      </b-button>
                    </div>                     
                  </b-col>
                </b-row>
              </b-alert>
              <b-card no-body> 
                <div >
                  <b-table
                  hover
                  small
                  bordered
                  :fields="fields"
                  :items="savedReports"
                  empty-text="No  records found"
                  show-empty
                  responsive
                  ref="scrollableTable"
                >
                  <template #cell(movie_title)="data">
                    <div style="width: 350px;">
                      {{ data.item.movie_title }}
                    </div>
                  </template>
                  <template #cell(Sr)="data">
                    <div class="text-nowrap text-center">
                      {{ data.index + 1 }}
                      <h6 v-if="data.item.isFinalReport == 1">
                        <b-badge variant="light-danger">{{
                          data.item.isFinalReport == 1 ? "Final/Last" : ""
                        }}</b-badge>
                      </h6>
                      <h6 v-if="data.item.isReportSent == 1">
                        <b-badge variant="light-danger">{{
                          data.item.isReportSent == 1 ? "Sent" : ""
                        }}</b-badge>
                      </h6>
                      <hr />
                      <b-button
                        v-if="data.item.reportContractId"
                        @click.stop="
                          $router.push(
                            `/contracts/form/${data.item.reportContractId}`
                          )
                        "
                        size="sm"
                        variant="link"
                        ><b><u>View Contract</u></b></b-button
                      >
                    </div>
                  </template>
                  <template #cell(dateFrom)="data">
                    {{
                      data.value
                        ? moment(data.item.dateFrom).format("DD/MM/YYYY") +
                          " to " +
                          moment(data.item.dateTo).format("DD/MM/YYYY")
                        : ""
                    }}
                  </template>

                  <template #cell(balance_to_favor)="data">
                    <b>{{
                      "CHF " + formatCurrency(data.item.balance_to_favor)
                    }}</b>
                  </template>

                  <template #cell(createdAt)="data">
                    {{
                      data.value ? moment(data.value).format("DD/MM/YYYY") : ""
                    }}
                  </template>

                  <template #cell(actions)="data">
                    <div class="text-nowrap" style="margin-top:2%;">
                      <div style="display:flex ; gap: 2% ; justify-content: center;align-items: center;">
                      <b-button
                        class="mr-1"
                        :variant="selectedRadio != 'showdeleted' ? 'outline-success' : 'outline-danger'"
                        size="sm"
                        style="width:4.5rem"
                        @click="onPreviewRoyalty(data.item.royalty_report_id)"
                        >
                        <feather-icon icon="EyeIcon" size="16" style="font-weight:600;font-family:Verdana, Geneva, Tahoma, sans-serif" />
                        </b-button
                      >

                      <b-button
                        :variant="selectedRadio != 'showdeleted' ? 'outline-success' : 'outline-danger'"
                        size="sm"
                        style="width:4.5rem; margin-right: 10px;"
                        @click="
                          onDownloadRoyalty(
                            data.item.royalty_report_document,
                            data.item.company
                          )
                        "
                        >
                        <feather-icon icon="DownloadIcon" size="16" style="font-weight:600;font-family:Verdana, Geneva, Tahoma, sans-serif" />
                        </b-button
                      >

                      <b-button
                        v-if='selectedRadio != "showdeleted"'
                        :variant="selectedRadio != 'showdeleted' ? 'outline-success' : 'outline-danger'" 
                        size="sm"
                        style="width:4.5rem; "
                        @click="handleDeleteRoyaltyReport(data.item)"
                        >
                        <feather-icon icon="TrashIcon" size="16" style="font-weight:600;font-family:Verdana, Geneva, Tahoma, sans-serif" />
                        </b-button
                      >
                    </div>  

                      <br />
                      <!-- <invoice-sidebar-send-invoice
                        ref="sendInvoiceSidebar"
                        :id="data.item.royalty_report_id"
                        type="RoyaltyInvEmail"
                        hide=false
                      /> -->
                      <b-button
                        v-if='selectedRadio != "showdeleted"'
                        block
                        class="mt-1"
                        variant="outline-success"
                        size="sm"
                        @click="handleMarkAsSent(data.item)"
                        >{{
                          data.item.isReportSent == 0 ? "Set " : "Unset"
                        }}
                        Report as Sent</b-button
                      >
                      <b-button
                        v-if='selectedRadio != "showdeleted"'
                        block
                        class="mt-1"
                        variant="outline-success"
                        size="sm"
                        @click="handleMarkAsFinal(data.item)"
                        >{{
                          data.item.isFinalReport == 0 ? "Set " : "Unset"
                        }}
                        Report as final/last</b-button
                      >
                      <!-- <b-tooltip
                        title="Preview Report"
                        class="cursor-pointer"
                        :target="`invoice-row-${data.item.royalty_report_id}-send-icon`"
                      /> -->
                      <b-button
                        v-if='selectedRadio != "showdeleted"'
                        block
                        class="mt-1"
                        variant="outline-success"
                        size="sm"
                        @click="handleSendButtonClicked(data.item)"
                      >
                        Send Royalty Report</b-button
                      >

                    </div>
                  </template>

                  <template #cell(upload)="row">
                    <div style="width: 100px">
                      <files-container
                        v-model="row.item.royalty_report_extra_document"
                        @remove="removeFile(
                          row.item.royalty_report_id,
                          row.item.royalty_report_extra_document
                        )"
                      />
                    </div>
                    <b-button
                      block
                      class="mt-1"
                      variant="outline-warning"
                      size="sm"
                      v-if="
                        row.item.royalty_report_extra_document &&
                        row.item.royalty_report_extra_document.length > 0
                      "
                      @click="
                        SaveRoyaltyReportDocument(
                          row.item.royalty_report_id,
                          row.item.royalty_report_extra_document
                        )
                      "
                    >
                      Save
                    </b-button>
                  </template>
                  </b-table>
                </div> 
                <invoice-sidebar-send-invoice
                  :key="sidebarKey"
                  ref="sendInvoiceSidebar"
                  :id="selectedRoyaltyReportId"
                  type="RoyaltyInvEmail"
                />
                  
                <template #footer>
                  <div class="mx-2 mb-2">
                    <b-row>
                      <!-- Pagination -->
                      <b-col
                        class="d-flex align-items-center justify-content-center justify-content-sm-center"
                      >
                        <b-pagination
                          @change="onPageChange"
                          v-model="pagination.currentPage"
                          :total-rows="pagination.total"
                          :per-page="pagination.perPage"
                          first-number
                          last-number
                          class="mb-0 mt-1 mt-sm-0"
                          prev-class="prev-item"
                          next-class="next-item"
                          :limit="15"
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </b-col>
                    </b-row>
                  </div>
                </template> </b-card
            ></b-tab>
            <!-- <b-tab title="Pending Royalty Reports As Per Statement Period">
             
              <div v-if="tabIndex == 2">
                <pending-royalty-report
                  ref="pendingComponentRef"
                  @setReportDataEmit="getReportData"
                  :selectedVendorId="
                    selectedCustomer ? selectedCustomer.vendor_id : null
                  "
                  :selectedMovieId="
                    selectedMovie && selectedMovie.movie_id
                      ? selectedMovie.movie_id
                      : null
                  "
                />
              </div>
            </b-tab> -->
          </b-tabs>
        </div>
      </b-col>
    </b-row>
    <div>
      <b-modal
        scrollable
        v-model="modalContract"
        id="modalContract"
        size="xl"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <b-table
          bordered
          class="position-relative"
          primary-key="contract_id"
          responsive
          show-empty
          :items="contractsList"
          :fields="fieldsContract"
          hover
        >
          <!-- hover -->
          <template #head(selected)="data">
            <b-form-checkbox
              @change="selectAllRows"
              v-model="selectAllStatus"
              value="1"
              unchecked-value="0"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(selected)="data">
            <b-form-checkbox
              v-model="selectedRotaltyContracts"
              :value="data.item"
            >
            </b-form-checkbox>
          </template>
          <template #cell(contract_id)="data">
            {{ data.item.contract_id }}
          </template>

          <template #cell(company)="data">
            <div style="width: max-content">
              <b-badge variant="light-success">
                {{ data.item.contract_nature
                }}{{ data.item.draft ? "(draft)" : "" }}</b-badge
              ><br />{{ data.item.company }}
            </div>
          </template>
          <template #cell(title)="data">
            <div style="width: max-content" v-html="data.value"></div>
          </template>
          <template #cell(territory)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(right)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(language)="data">
            <span>
              {{ data.value }}
            </span>
          </template>
          <template #cell(purchaseDate)="data">
            <b-badge variant="light-info"
              >Contract Date : {{ data.item.purchaseDate }} </b-badge
            ><br />
            <b-badge variant="light-success" class="mt-1">
              Start : {{ data.item.rStart }} </b-badge
            ><br />

            <b-badge variant="light-danger" class="mt-1">
              End : {{ data.item.rExpiry }}</b-badge
            >
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                variant="primary"
                size="sm"
                @click="getRoyaltyReportMultiple(data.item)"
                class="borderRadius-10"
              >
                Preview Report </b-button
              ><br />
              <b-badge
                pill
                variant="light-success"
                v-if="selectedContractID === data.item.contract_id"
                >currently on preview</b-badge
              >

              <!-- <b-button
                size="sm"
                @click="data.toggleDetails, getRoyaltyReportMultiple(data.item)"
              >
                {{ data.detailsShowing ? "Hide" : "Show" }} Details
              </b-button> -->
            </div>
          </template>
          <template #row-details="row"> </template>
          <template #cell()="data">
            <span class="text-nowrap">{{ data.value }}</span>
          </template>
        </b-table>
      </b-modal>
    </div>
    <b-modal
      scrollable
      v-model="modalPreview"
      id="modalPreview"
      size="xl"
      hide-footer
    >
      <preview-invoice
        :selected_royalty_report_id="selected_royalty_report_id"
      />
    </b-modal>

    <!-- <invoice-sidebar-send-invoice />
    <invoice-sidebar-add-payment /> -->
    <div>
      <revenue-expenses-contract 
        :type="selected_type" 
        :showModals="showRevenueExpensesModal"
        :contract_id="reportContractId"
        @modal-cancel="handleRevenueExpensesModalCancel"
      />
    </div>
    <royalty-report-info-modal
      v-model="showReportInfoModal"
      :is-territory="false"
      :report-data="royaltyReportData"
    />
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import { labels } from "@/utils/constants";
import * as ContractServices from "@/apiServices/ContractServices";
import previewInvoice from "./PreviewRoyaltyReport.vue";
import pendingRoyaltyReport from "./PendingRoyaltyReports.vue";
import showModal from "@/views/components/ModalConfirmation";

import {
  GetRoyaltyReportDataMultiple,
  GetRoyaltyReportList,
  GenerateRoyaltyReportPDF,
  GetMoviesVendor,
  GetVendorMovies,
  SaveRoyaltyServices,
  DeleteRoyaltyReport,
} from "@/apiServices/RevenueServies";
import { formatCurrency } from "@/utils/helpers";

import { getAllMovie } from "@/apiServices/MovieServices";
import { getAllVendor } from "@/apiServices/VendorServices";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  BAlert,
  BLink,
  VBToggle,
  BTable,
  BTooltip,
  BSpinner,
  BPagination,
  BTabs,
  BTab,
  BModal,
  BBadge,
  BFormRadio,
  BFormRadioGroup,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import ToastificationContentVue from "@core/components/toastification/ToastificationContent.vue";
import InvoiceSidebarSendInvoice from "../Revenue/InvoiceSidebarSendInvoice.vue";
// import InvoiceSidebarAddPayment from '../InvoiceSidebarAddPayment.vue'
import FilesContainer from "@/views/components/FilesUpload/FilesContainer.vue";
import AllFilesUpload from "@/views/components/FilesUpload/AllFilesUpload.vue";
import RevenueExpensesContract from "../Revenue/RevenueExpensesContract.vue";
import RoyaltyReportInfoModal from "./RoyaltyReportInfoModal.vue";


export default {
  components: {
    BRow,
    BTabs,
    BTab,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    BAlert,
    BLink,
    flatPickr,
    vSelect,
    Logo,
    BTable,
    BTooltip,
    ToastificationContentVue,
    BSpinner,
    BPagination,
    BModal,
    BBadge,
    BFormRadio,
    previewInvoice,
    BFormRadioGroup,
    pendingRoyaltyReport,
    BListGroup,
    BListGroupItem,
    AllFilesUpload,
    FilesContainer,
    InvoiceSidebarSendInvoice,
    // InvoiceSidebarAddPayment,
    RevenueExpensesContract,
    RoyaltyReportInfoModal
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },

  data() {
    return {
      isReportSelectOpen: false,
      documentToSend: [],
      documentToSendId: [],
      isSendButtonClicked: false,
      uploadedFilesPrev: [],
      selectedRadio: "all",
      currentInvoiceId: null,
      sidebarType: "",
      optionsRadio: [
        { text: "All", value: "all" },
        { text: "Sent", value: "isReportSent" },
        { text: "Final/Last", value: "isFinalReport" },
        { text: "Show Deleted Reports", value: "showdeleted" },
      ],
      BASE_URL_FILES: process.env.VUE_APP_FILESURL + '/',
      moment: moment,
      pagination: {
        currentPage: 1,
        total: null,
        perPage: 10,
      },
      filters: {
        reportType: 'default',
        showReportBy: 'vendor',
        reportView: 'rights',
        licensor: null,
        movie: null,
        revenueDate: null,
      },
      selectAllStatus: "0",
      selectedRotaltyContracts: [],
      selected_royalty_report_id: null,
      perPageOptions: [10, 25, 50, 100],
      fields: [
        "Sr",
        { key: "company", label: "Licensor" },
        { key: "movie_title", label: "Movie" },

        // { key: "territory_name", label: "Territory" },
        { key: "dateFrom", label: "Duration" },
        { key: "balance_to_favor", label: "Balance to favor/Unrecouped" },

        { key: "createdAt", label: "Report Generate Date" },
        { key: "reportSentTo", label: "Sent to" },
        { key: "reportDescription", label: "Comments" },
        { key: "actions", label: "Actions" },
        { key: "upload", label: "Upload" },
        { key: "reportCreatedByName", label: "Created By" },
      ],
      // selectedCustomer: null,
      // orderValue: "vendor",
      // rightsView: "rights",
      // reportTypeValue: "default",
      loading: false,
      tabIndex: 0,
      modalContract: false,
      modalPreview: false,
      // revenueDateRange: null,
      optionCustomer: [],
      optionCustomerTemp: [],
      optionMovies: [],
      optionMultipleMovies: [],
      optionVendors: [],
      optionAvailableTeritory: [],
      isMovieLoading: false,
      isVendorLoading: false,
      rights_tree: [],
      report_rights: [],
      // selectedMovie: null,
      movieName: null,
      reportContractId: null,
      selectedContractID: null,
      optionTeritory: [],
      contractsList: [],
      allTeritory: [],
      savedReports: [],
      vendorAllReports: [],
      trl_territories: [],
      selectedTeritory: null,
      royaltyReportData: null,
      isFinalReport: false,
      finalReportstatus: false,
      isGenerateAll: false,
      reportDescription: null,
      reportSentTo: null,
      reportSearchSection: true,
      showReportSearchSection: true,
      fieldsContract: [
        { key: "selected", label: "", stickyColumn: true },

        {
          key: "actions",
          label: "Actions",
          stickyColumn: true,
          variant: "primary",
        },

        {
          key: "company",
          label: "Contact",
        },
        {
          key: "title",
          label: "Movie",
        },
        {
          key: "territory",
          label: "territory",
        },
        {
          key: "right",
          label: "rights",
        },
        {
          key: "language",
          label: "languages",
        },
        {
          key: "purchaseDate",
          label: "contract dates",
        },

        {
          key: "language",
          label: "languages",
        },
        { key: "contract_id", label: "Contract ID" },
      ],
      showRevenueExpensesModal:false,
      showReportInfoModal: false,
      currentContractData: null,
      selected_type:'royalty_report_right',
      scrollPosition: 0,
      maxScroll: 0,
      isAtRightEnd: false,
      showScrollButtons: true, 
      selectedRoyaltyReportId: null,
      sidebarKey: 0,
    };
  },

  mounted() {
    this.filters.reportType = 'default';
    // this.loadFilterList();
  

    this.$nextTick(() => {
      this.updateScrollState();
      const el= this.getTableElement()
      if (el) {
        el.addEventListener('scroll', this.handleScroll)
        setTimeout(this.updateScrollState, 300) // Wait for DOM to render
      }
    })
  },
  beforeDestroy() {
    const el = this.getTableElement()
    if (el) {
      el.removeEventListener('scroll', this.handleScroll)
    }
  },
  
  async beforeMount() {
    this.filters.reportType = 'default';
    this.loadFilterList();
    // console.log('movie:', this.filters.movie);
    if (this.filters.showReportBy == 'vendor') {
      this.getLicensorMovies('no');
    } else {
      this.getMoviesLicensor();
    }
    this.GetSavedReports();
    this.GetAllVendor();
    this.GetAllMovie();
    this.handleSetContract();
  },
  computed: {
    isAtLeftEnd() {
      return this.scrollPosition <= 0;
    },
    buttonIcon() {
      return this.isAtRightEnd ? 'ArrowLeftIcon' : 'ArrowRightIcon';
    },
    buttonTooltip() {
      return this.isAtRightEnd ? 'Scroll to beginning' : 'Scroll to end';
    },
    selectedContractsOptions() {
      // guard against null/undefined entries that would produce duplicate keys
      return (this.selectedRotaltyContracts || []).filter(
        (item) => item && item.contract_id !== undefined && item.contract_id !== null
      );
    },
  },

  watch: {
    // limit() {
    //   this.getAllRevenueData();
    // },
    // currentPage() {
    //   this.getAllRevenueData();
    //   this.$refs["table_container"].scrollIntoView({ behavior: "smooth" });
    // },
    selectedRotaltyContracts() {
      if (this.selectedRotaltyContracts.length > 0) {
        if (this.selectedRotaltyContracts.length != this.contractsList.length) {
          this.selectAllStatus = "0";
        } else {
          this.selectAllStatus = "1";
        }
      } else {
      }
    },
  },
  methods: {

  getOptionLabel(option) {
    return `Report ${this.getReportIndex(option.contract_id)} - ${option.title}`;
  },
  getReportIndex(contractId) {
    const index = this.selectedRotaltyContracts.findIndex(
      item => item.contract_id === contractId
    );
    return index >= 0 ? index + 1 : '';
  },
  handleReportSelect(contractId) {
    const selected = this.selectedRotaltyContracts.find(
      item => item.contract_id === contractId
    );
    if (selected) {
      this.getRoyaltyReportMultiple(selected);
    }
  },

    handleSendButtonClicked(dataArray) {
      console.log(dataArray,'value send to component') ;
      this.isSendButtonClicked = true;
      this.selectedRoyaltyReportId = dataArray.royalty_report_id;
      this.sidebarKey++;
      // const correspondingVendor = this.optionVendors.find(vendor => 
      //    vendor.vendor_id === dataArray.vendor_id // Assuming item has vendor_id that matches
      // );
      // console.log(correspondingVendor,'matchingVendor') ;
      this.$nextTick(() => {
        if (this.$refs.sendInvoiceSidebar) {
          const contact_emails = this.optionVendors
                                  .filter((vendor)=> vendor.vendor_id === dataArray.vendor_id)
                                  .map((vendor) => vendor.vendor_contactpersons ? vendor.vendor_contactpersons : []) ;
          // console.log(contact_emails,'contact_emails') ;
          this.$refs.sendInvoiceSidebar.showSidebar(dataArray,contact_emails);
          console.log('dataArray',dataArray) ;
        }
      });
    },
    handleSetContract() {
      if (
        this.selectedRotaltyContracts.length > 0 &&
        !this.selectedContractID
      ) {
        // console.log(selectedRotaltyContracts, "contractsOnMounting");
        this.selectedContractID = this.selectedRotaltyContracts[0].contract_id;
        // console.log("defaultContractIdValue", this.selectedContractID);
      }
    },
    formatCurrency,
    openSidebar(type) {
      this.$refs.childComponent.showSidebar(type);
    },
    showInvoiceSidebar(type) {
      this.sidebarType = type;
      this.$nextTick(() => {
        if (this.$refs.sendInvoiceSidebar) {
          this.$refs.sendInvoiceSidebar.showSidebar(type);
        }
      });
    },
    async onDownloadRoyalty(file, outputFileName) {
      const fileName = this.BASE_URL_FILES + file;

      try {
        const response = await fetch(fileName);
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = outputFileName + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.log({ err });
      }
    },
    async onGenrateAll() {
      this.isGenerateAll = true;

      for (let i of this.selectedRotaltyContracts) {
        this.loading = true;
        await this.getRoyaltyReportMultiple(i);

        await this.GenerateRoyaltyReportPdf(this.royaltyReportData);
      }
      this.loading = false;
      this.tabIndex = 1;
      this.loadFilterList();
      this.GetSavedReports();
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title: "Generated Succesfully",
          icon: "EditIcon",
          variant: "success",
        },
      });
    },

    selectAllRows() {
      if (this.selectAllStatus == "1") {
        this.selectedRotaltyContracts = this.contractsList;
      } else {
        this.selectedRotaltyContracts = [];
      }
      this.selectedContractID = this.contractsList[0].contract_id
    },
    async getReportData(data) {
      let nextFromDate = data.lastReportCreatedDate
        ? moment(data.lastReportCreatedDate).format("YYYY-MM-DD")
        : moment(data.contractCreatedDate).format("YYYY-MM-DD");
      let nextToDate = null;
      if (data.statementPeriod == "1") {
        nextToDate = moment(nextFromDate).add(1, "months");
      } else if (data.statementPeriod == "2") {
        nextToDate = moment(nextFromDate).add(6, "months");
      } else if (data.statementPeriod == "3") {
        nextToDate = moment(nextFromDate).add(3, "months");
      } else if (data.statementPeriod == "4") {
        nextToDate = moment(nextFromDate).add(12, "months");
      }
      nextToDate = moment(nextToDate).format("YYYY-MM-DD");
      this.filters.revenueDate = nextFromDate + " to " + nextToDate;
      this.getRoyaltyReportMultiple(data);
    },
    async onPreviewRoyalty(id) {
      this.selected_royalty_report_id = id;
      this.modalPreview = true;
    },
    async onReportChange() {
      this.onChange();
      if (this.filters.reportType == "territory") {
        this.$router.push(`/generateroyaltyterritory`);
      }
    },
    async onOrderChange() {
      this.filters.movie = null;
      this.filters.licensor = null;
      this.filters.revenueDate = null;
      this.royaltyReportData = null;
      if (this.filters.showReportBy == "vendor") {
        //this.GetAllVendor();
      } else if (this.filters.showReportBy == "movie") {
        // this.GetAllMovie();
      }
      this.onChange();
    },
    async handleMarkAsSent(item) {
      const confirmation = await this.showModal(
        `Are you sure you want to ${
          item.isReportSent == 0 ? "set " : "unset"
        } Report as Sent?`,
        "save"
      );

      if (confirmation) {
        this.updateFinalStatus(
          item.royalty_report_id,
          item.isFinalReport,
          item.isReportSent,
          "sent"
        );
      }
    },
    async handleMarkAsFinal(item) {
      const finalConfirmation = await this.showModal(
        `Are you sure you want to ${
          item.isFinalReport == 0 ? "set" : "unset"
        } report as final`,
        "save"
      );
      if (finalConfirmation) {
        this.updateFinalStatus(
          item.royalty_report_id,
          item.isFinalReport,
          item.isReportSent,
          "final"
        );
      }
    },
    async handleDeleteRoyaltyReport(item) {
      if (item.isFinalReport == 1 || item.isReportSent == 1) {
        let reasons = [];

        if (item.isFinalReport == 1) {
          reasons.push("Final/Last");
        }
        if (item.isReportSent == 1) {
          reasons.push("Sent");
        }
        const message = `You cannot delete this report as it is set to ${reasons.join(" and ")}.`;

        await this.showModal(message,'delete', false);
        return;
      }
      const confirmation = await this.showModal(
        "Are you sure you want to delete this royalty report?",
        "delete"
      );
      if (confirmation) {
        try {
          const payload = { royalty_report_id: item.royalty_report_id };
          const response = await DeleteRoyaltyReport(payload)
          
          if (response.data.status) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: "Report Deleted successfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.GetSavedReports();
          } else {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "Delete failed",
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        } catch (err) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Error deleting report",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      }
    },
   showModal(text = "Are You Sure?", type = "save", withButtons = true) {
      if (withButtons) {
        return this.$bvModal
          .msgBoxConfirm(text, {
            title: "Confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: type == "save" ? "success" : "danger",
            cancelVariant: type == "save" ? "outline-success" : "outline-danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          });
      } else {
        return this.$bvModal
          .msgBoxOk(text, {
            title: "Information",
            size: "sm",
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: "OK",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          });
      }
    },


    async GetSavedReports() {
      try {
        let payload = {
          page: this.pagination.currentPage,
          reportContractId: this.reportContractId,
          limit: this.pagination.perPage ? this.pagination.perPage : null,
          vendor_id:
            this.filters.licensor && this.filters.licensor.vendor_id
              ? this.filters.licensor.vendor_id
              : null,
          movie_id:
            this.filters.movie && this.filters.movie.movie_id
              ? this.filters.movie.movie_id
              : null ||
                (this.filters.movie && this.filters.movie.multi_movies_ids)
              ? this.filters.movie.multi_movies_ids
              : null,
          territory_id: this.selectedTeritory ? this.selectedTeritory : null,
          selectedRadio: this.selectedRadio,
          // range: this.revenueDateRange
          //   ? this.revenueDateRange.split("to")
          //   : null,
        };

        const response = await GetRoyaltyReportList(payload);

        if (!response.status) {
          return this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Data not found!",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        this.savedReports = response.data.data.data;
        if (
          response.data.data.hasOwnProperty("pagination") &&
          response.data.data.pagination.total
        ) {
          this.pagination.total = response.data.data.pagination.total;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      }
    },
    async GetAllMovie() {
      this.isMovieLoading = true;
      try {
        const response = await getAllMovie({ archived: false, draft: false });
        if (response.data) {
          this.optionMovies = response.data.data.data;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      } finally {
        this.isMovieLoading = false;
      }
    },

    async GetAllVendor() {
      this.isVendorLoading = true;
      try {
        const response = await getAllVendor({
          contact_type:"Royalty report",
          lbl_cat:"contact_type"
        });
        if (response.data) {
          this.optionVendors = response.data.data.data;
        }
      } catch (err) {
        console.log("Error in getting vendors list ", err);
      } finally {
        this.isVendorLoading = false;
      }
    },
    async updateFinalStatus(reportId, finalStatus, isReportSent, type) {
      try {
        let final;
        let sent;
        if (type == "final") {
          final = finalStatus && finalStatus == 1 ? 0 : 1;
        } else {
          final = finalStatus;
        }

        if (type == "sent") {
          sent = isReportSent && isReportSent == 1 ? 0 : 1;
        } else {
          sent = isReportSent;
        }

        const response = await GenerateRoyaltyReportPDF({
          royalty_report_id: reportId,
          finalStatus: final,
          isReportSent: sent,
        });
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.loadFilterList();
          this.GetSavedReports();
        }
      } catch (error) {
        console.log("Error in updating status");
      }
    },
    onSelect(selectedMovie) {
      // console.log(selectedMovie);
      // let getData = this.vendorAllReports.filter((z) => {
      //   return (
      //     z.movie_id == selectedMovie.multi_movies_ids &&
      //     String(z.vendor_id) == String(selectedMovie.vendor_id)
      //   );
      // });
      // console.log(getData, "movie");
      // if (getData.length) {
      //   this.revenueDateRange = getData[0].dateTo;
      // } else {
      //   this.revenueDateRange = "";
      // }
    },
    onTabChange() {
      this.filters.movie = null;
      this.movieName = null;
      this.filters.licensor = null;
      this.filters.revenueDate = null;
    },

    onPageChange() {
      this.$nextTick(() => {
        this.loadFilterList();
        this.GetSavedReports();
      });
    },

    async getLicensorMovies(isMultiple) {
      this.optionMultipleMovies = [];
      this.vendorAllReports = [];
      this.isMovieLoading = true;
      // this.selectedMovie = null;
      try {
        const response = await GetVendorMovies({
          vendor_id: this.filters.licensor.vendor_id,
          isMultiple: isMultiple,
        });
        if (response.data.status) {
          this.optionMultipleMovies = response.data.data.vendors;
          this.vendorAllReports = response.data.data.reportStrtDate;
          if (this.optionMultipleMovies.length == 1) {
            this.filters.movie = this.optionMultipleMovies[0];
            //this.onSelect(this.selectedMovie);
          }
          const notSameMovieOption = !this.optionMultipleMovies.some(MovieOption => MovieOption.contract_id === this.filters.movie.contract_id);
          if (notSameMovieOption){
            this.filters.movie = null;
          }
        }
      } catch (error) {
        console.log("Error in getting Contracts List");
      } finally {
        this.isMovieLoading = false;
      }
      this.onChange();
    },
    async getMoviesLicensor() {
      this.optionCustomer = [];
      // this.selectedCustomer = null;
      this.isVendorLoading = true;

      try {
        const response = await GetMoviesVendor({
          movie_id: this.filters.movie.movie_id,
        });
        if (response.data.status) {
          this.optionCustomer = response.data.data;
        }
        const notSameLicensorOption = !this.optionCustomer.some(VendorOption => VendorOption.vendor_id === this.filters.licensor.vendor_id);
        if (notSameLicensorOption){
          this.filters.licensor = null;
        }
      } catch (error) {
        console.log("Error in getting Contracts List");
      } finally {
        this.isVendorLoading = false;
      }
      this.onChange();
    },
    searchSavedReports() {
      this.tabIndex = this.tabIndex;
      this.royaltyReportData = null;
      if (this.tabIndex == 2) {
        this.$refs.pendingComponentRef.getContractsList();
      }
      this.loadFilterList();
      this.GetSavedReports();
    },

    async GenerateRoyaltyReportPdf(payload) {
      this.loading = true;
      try {
        payload.searchValues = {
          vendor_id: this.filters.licensor.vendor_id,
          movie_id:
            this.filters.movie && this.filters.movie.movie_id
              ? this.filters.movie.movie_id
              : null,
          reportContractId: this.reportContractId,
          territory_id: 0,
          expense_date: this.filters.revenueDate,
        };
        let vendorData = this.optionVendors.filter((x) => {
          return x.vendor_id == this.filters.licensor.vendor_id;
        });
        if (vendorData.length) {
          this.filters.licensor = vendorData[0];
        }
        payload.headData = {
          territory_name: "",
          tilte_name:
            this.filters.movie && this.filters.movie.title
              ? this.filters.movie.title
              : null,
          vendor_name: this.filters.licensor,
        };
        payload.isFinalReport = this.isFinalReport == true ? 1 : 0;
        payload.reportDescription = this.reportDescription;
        payload.reportSentTo = this.reportSentTo;
        payload.isRRTerritoryWise = false;
        let tempReportHtml = this.$refs.rrt_table;
        payload.reportHtml = tempReportHtml.outerHTML;

        const response = await GenerateRoyaltyReportPDF(payload);
        if (response.data.status) {
          if (this.isGenerateAll == false) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: response.data.message || "PDF Generated Succesfully",
                icon: "EditIcon",
                variant: "success",
              },
            });
            this.selected_royalty_report_id =
              response.data.data.royalty_report_id;
            this.modalPreview = true;
            this.loadFilterList();
            this.GetSavedReports();
          }
          // this.$router.push({
          //   name: "PreviewRoyaltyReport",
          //   params: {
          //     royalty_report_id: response.data.data.royalty_report_id,
          //   },
          // });
          //this.searchSavedReports();
          this.loading = false;

          //this.optionCustomer = response.data.data.rows;
        }
      } catch (err) {
        this.loading = false;
        console.log("Error in adding ", err);
      }
    },

    // async getReportContracts() {
    //   try {
    //     this.reportDescription = "";

    //     this.selectAllStatus = "0";
    //     if (this.selectedMovie) {
    //       this.sendButtonStatus[this.selectedMovie.movie_id] = true;
    //     }
    //     if (this.selectedCustomer) {
    //       this.sendButtonStatus[this.selectedCustomer.vendor_id] = true;
    //     }
    //     const response = await ContractServices.getAllContract({
    //       movie:
    //         this.selectedMovie && this.selectedMovie.multi_movies_ids
    //           ? this.selectedMovie.multi_movies_ids
    //           : this.selectedMovie && this.selectedMovie.movie_id
    //           ? this.selectedMovie.movie_id
    //           : null,
    //       vendor: this.selectedCustomer
    //         ? this.selectedCustomer.vendor_id
    //         : null,
    //       contract_nature: "Acquisition",
    //       from: this.revenueDateRange
    //         ? this.revenueDateRange.split("to")[0]
    //         : "",
    //       to: this.revenueDateRange ? this.revenueDateRange.split("to")[1] : "",
    //     });
    //     this.contractsList = response.data.data.contracts;

    //     if (!response.data.data.contracts.length) {
    //       this.$toast({
    //         component: ToastificationContentVue,
    //         props: {
    //           title: "Acquisition Contract Not Found!",
    //           icon: "EditIcon",
    //           variant: "danger",
    //         },
    //       });
    //     }
    //     //  else if (this.contractsList.length == 1) {
    //     //   this.getRoyaltyReportMultiple(this.contractsList[0].contract_id);
    //     // }
    //     else {
    //       this.modalContract = true;
    //     }
    //   } catch (error) {
    //     console.log("Error in getting Contracts List", error);
    //   }
    // },
    async getReportContracts() {
      console.log("it is")
      this.loadFilterList();
      try {
        this.reportDescription = "";
        this.selectAllStatus = "0";
        this.selectedRotaltyContracts = [];
        const response = await ContractServices.getAllContract({
          movie:
            this.filters.movie && this.filters.movie.multi_movies_ids
              ? this.filters.movie.multi_movies_ids
              : this.filters.movie && this.filters.movie.movie_id
              ? this.filters.movie.movie_id
              : null,
          vendor: this.filters.licensor
            ? this.filters.licensor.vendor_id
            : null,
          contract_nature: "Acquisition",
          from: this.filters.revenueDate
            ? this.filters.revenueDate.split("to")[0]
            : "",
          to: this.filters.revenueDate ? this.filters.revenueDate.split("to")[1] : "",
        });
        this.contractsList = response.data.data.contracts;

        if (!response.data.data.contracts.length) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Acquisition Contract Not Found!",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        //  else if (this.contractsList.length == 1) {
        //   this.getRoyaltyReportMultiple(this.contractsList[0].contract_id);
        // }
        else {
          this.modalContract = true;
        }
      } catch (error) {
        console.log("Error in getting Contracts List", error);
      }
    },
    async getRoyaltyReportMultiple(contractData) {
      this.currentContractData = contractData;
      if (this.selectedContractID != contractData.contract_id) {
        this.rights_tree = [];
        this.report_rights = [];
      }

      this.tabIndex = 0;
      let obj = {
        vendor_id: contractData.vendor_id,
        company: contractData.company,
      };

      this.filters.licensor = obj;

      this.modalContract = false;
      this.reportContractId = contractData.contract_id;
      this.showRevenueExpensesModal = false;
      console.log(
        "selectedContractID",
        this.reportContractId,
        // contractData.contract_id
      );

      let loader = null;
      try {
        let movie_array = [];
        let selected_m_id = contractData.movie_ids.split(",");

        for (let i of selected_m_id) {
          let getMovie = this.optionMovies.filter((y) => {
            return y.movie_id == i;
          });

          if (getMovie.length > 0) {
            let obj = {
              title: getMovie[0].title,
              movie_id: i,
            };
            movie_array.push(obj);
          } else {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: "Something Went Wrong in Selecting Contract",
                icon: "EditIcon",
                variant: "danger",
              },
            });
            break;
            return;
          }
        }

        let payload = {
          contractID: contractData.contract_id,
          vendor_id: contractData.vendor_id,
          movie_id: movie_array,
          territory_id: this.selectedTeritory ? this.selectedTeritory : null,
          fromDate: this.filters.revenueDate
            ? this.filters.revenueDate.split("to")[0]
            : "",
          toDtae: this.filters.revenueDate
            ? this.filters.revenueDate.split("to")[1]
            : "",
          rightsView: this.filters.reportView,
          report_rights: this.report_rights,
        };

        // Show loader before data fetching starts
        loader = this.$loading.show();

        const response = await GetRoyaltyReportDataMultiple(payload);

        if (response.data) {
          this.royaltyReportData = response.data.data;
          this.reportDescription = this.royaltyReportData.reportDescription
          if (
            this.royaltyReportData.licensorArray &&
            this.royaltyReportData.licensorArray.length &&
            this.selectedContractID != contractData.contract_id
          ) {
            for (let i of this.royaltyReportData.licensorArray[0]) {
              if (this.filters.reportView == "subRights") {
                let index = this.rights_tree.findIndex((x) => x.id == i.id);
                console.log(index, "i");
                if (index >= 0) {
                  this.rights_tree[index].children.push({
                    key: i.id,
                    id: i.id,
                    lbl_id: i.id,
                    title: i.subrightsNamesString,
                    label: i.subrightsNamesString,
                    value: i.id,
                  });
                } else {
                  let objSub = {
                    key: i.id,
                    id: i.id,
                    lbl_id: i.id,
                    title: i.rightName,
                    label: i.rightName,
                    value: i.id,
                    lbl_is_group: 0,
                    children:[]
                    // children: [
                    //   {
                    //     key: i.sub_id,
                    //     id: i.sub_id,
                    //     lbl_id: i.sub_id,
                    //     title: i.rightName,
                    //     label: i.rightName,
                    //     value: i.sub_id,
                    //   },
                    // ],
                  };
                  if(objSub){
                    this.rights_tree.push(objSub);
                  }
                }
              } else {
                let obj = {
                  key: i.id,
                  id: i.id,
                  lbl_id: i.id,
                  title: i.rightName,
                  label: i.rightName,
                  value: i.id,
                  lbl_is_group: 0,
                  children:[]
                };
                if(obj){
                  this.rights_tree.push(obj);
                }
              }
            }
          }
          this.selectedContractID = contractData.contract_id;
          this.loadFilterList();
          this.GetSavedReports();
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      } finally {
        // Hide loader when fetch is done (success or error)
        if (loader) {
          loader.hide();
        }
      }
    },
    showGenerateConfirm(data) {
      this.onChange();
      this.$bvModal
        .msgBoxConfirm(
          "Once royalty report gets generated it will get added to system logs!.Are you sure, you want to proceed with generate royalty report?",
          {
            title: "Confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) this.GenerateRoyaltyReportPdf(data);
        })
        .catch((err) => {
          // An error occurred
        });
    },
    resetForm() {
      this.filters.reportType = 'default';
      this.filters.showReportBy = 'vendor';
      this.filters.reportView = 'rights';
      this.filters.licensor = null;
      this.filters.movie = null;
      this.filters.revenueDate = null;
      this.onChange();
      this.reportContractId = null;
      this.selectedRotaltyContracts = [];
      this.royaltyReportData = null;
      this.GetSavedReports();
    },

    checkForDuplicates(array) {
      const uniqueValues = new Set();

      for (const item of array) {
        const firstElement = item[0];
        if (uniqueValues.has(firstElement)) {
          return true;
        }
        uniqueValues.add(firstElement);
      }

      return false;
    },
    async SaveRoyaltyReportDocument(id, files) {
      try {
        const payload = {
          royalty_report_id: id,
          royalty_report_extra_document: files,
        };
        if (
          payload.royalty_report_extra_document !== null &&
          payload.royalty_report_extra_document.length > 0
        ) {
          console.log(payload.royalty_report_extra_document, "document value");
          const hasDuplicates = this.checkForDuplicates(
            payload.royalty_report_extra_document
          );
          if (hasDuplicates) {
            alert(
              "Duplicate files detected. Please remove duplicates before saving."
            );
            return;
          }
          const newFilesString = JSON.stringify(
            payload.royalty_report_extra_document
          );
          console.log(
            this.uploadedFilesPrev,
            "previous uploaded files before upload"
          );
          const prevFilesString = JSON.stringify(this.uploadedFilesPrev);
          if (newFilesString !== prevFilesString) {
            this.uploadedFilesPrev = [...payload.royalty_report_extra_document];
            const response = await SaveRoyaltyServices(payload);
            console.log("Document saved successfully:", response.data);
          } else {
            alert(
              "The uploaded files are the same as the previously saved files. Please upload different files."
            );
          }
        } else {
          alert("Upload some files to save.");
        }
      } catch (error) {
        console.error("Error saving document:", error);
      }
    },
    async removeFile(id, files) {
      try{
        const payload = {
          royalty_report_id: id,
          royalty_report_extra_document: files,
        }
        const response = await SaveRoyaltyServices(payload);
        console.log("File removed successfully:", response.data);
      } catch(error){
        console.error("Error removing file:", error);
      }
    },
    formattedTitle(title) {
      return title.includes('<br/>') ? 'Various' : title;
    },
    handleRevenueExpensesModalCancel() {
      this.showRevenueExpensesModal = false;
      
      // Refetch data for current contract
      if (this.currentContractData) {
        this.getRoyaltyReportMultiple(this.currentContractData);
      }
    },

    handle_report_type(type){
      console.log(type,"foiewhfweio")
      this.selected_type = type
    },

    onChange() {
      this.$nextTick(() => {
        localStorage.setItem(
          "filtersAndPaginationGenerateRoyaltyReport",
          JSON.stringify({
            filters: this.filters,
            pagination: this.pagination,
          })
        );
      });
    },
    loadFilterList() {
      const filtersAndPaginationGenerateRoyaltyReportStr = localStorage.getItem(
        "filtersAndPaginationGenerateRoyaltyReport"
      );
      if (filtersAndPaginationGenerateRoyaltyReportStr) {
        const obj = JSON.parse(filtersAndPaginationGenerateRoyaltyReportStr);
        this.filters = obj.filters;
        // this.$forceUpdate();
      }
    },
    // Method to get the table element for scrolling
    getTableElement() {
      return this.$refs.scrollableTable?.$el?.querySelector('.table-responsive') || this.$refs.scrollableTable?.$el // checks if the tables exists and returns
    },
    updateScrollState() {
      const el = this.getTableElement();
      if (el) {
      // Force synchronous layout calculation
      void el.offsetHeight;
      
      this.maxScroll = el.scrollWidth - el.clientWidth; //how much space we have to scroll 
      this.scrollPosition = el.scrollLeft; // current scroll position
    
      this.isAtRightEnd = this.maxScroll > 0 && 
                        Math.abs(this.scrollPosition - this.maxScroll) < 1;
      
      // Only show buttons if we have valid measurements
      this.showScrollButtons = this.maxScroll > 10;
      
      // console.log('Scroll State:', {
      //   scrollPosition: this.scrollPosition,
      //   scrollWidth: el.scrollWidth,
      //   clientWidth: el.clientWidth,
      //   scrollLeft: el.scrollLeft,
      //   maxScroll: this.maxScroll,
      //   isAtRightEnd: this.isAtRightEnd,
      //   showButtons: this.showScrollButtons
      //   });
      } else {
        // Default safe values if element not found
        this.isAtRightEnd = false;
        this.showScrollButtons = false;
      }
    },
    handleScrollClick() {
      
      this.$root.$emit('bv::hide::tooltip') // hide tooltip firstly
      const direction = this.isAtRightEnd ? 'left' : 'right';
      
      this.scrollTable(direction)
      
    },
    scrollTable(direction) {
      const el = this.getTableElement()
      if (el) {
        el.scrollLeft += direction === 'left' ? -el.scrollWidth : el.scrollWidth;
        this.updateScrollState()
      }
    },
    handleScroll() {
      this.updateScrollState()
    },
    onReportSelectOpen() {
      this.isReportSelectOpen = true;
    },
    onReportSelectClose() {
      this.isReportSelectOpen = false;
    },
  },
  // watch: {
  //   "row.item.royalty_report_extra_document": {
  //     handler(newVal) {
  //       console.log("royalty_report_extra_document changed:", newVal);
  //     },
  //     deep: true,
  //   },
  // },
//   watch: {
//     selectedRotaltyContracts: {
//       handler(newVal) {
//         if (newVal.length  && !this.selectedContractID) {
//           console.log(newVal,'newSelectedVal') ;
//           console.log(this.selectedContractID,'contractIdVal') ;
//           this.selectedContractID = newVal[0].contract_id;
//           console.log("contractIdDefaultValue", this.selectedContractID);
//         }
//       },
// // Trigger the handler immediately on mount
//     },
//   },
  created() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  // border: 1px solid #000;
  text-align: left;
  padding: 5px;

  text-align: right;
}

.spacing {
  background-color: #eaecfd;
}
br {
  border: 1px solid #000;
}
table {
  font-family: verdana !important;
}
table {
  table-layout: fixed !important;
}
td {
  width: 33% !important;
}
.scroll-buttons {
  position: relative;
  display: flex;
  top: 50%;
  left: 0;
  right: 0;
  justify-content: space-between;
  pointer-events: none;
  transform: translateY(-50%);
  &.show {
    display: flex;
  }
}
.dynamic-scroll-button {
  transition: all 0.3s ease;
  width: 35px;
  height: 35px;
  position:relative;
  display:flex;
  pointer-events: auto;
  z-index: 10;
}
.dynamic-scroll-button:hover {
  transform: scale(1.1);
}
.scroll-button.left {
  margin-left: -20px;
}
.scroll-button.right {
  margin-right: -20px;
}
.scroll-button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.table-responsive {
  scroll-behavior: smooth;
}
.bg-gray-200 {
  background-color: #e5e7eb;
}
.report-table {
  width: 100%;
  color: #000;
}
.font-bold {
  font-weight: 700;
}
.mb-8 {
  margin-bottom: 2rem;
}
.font-normal{
  font-weight: 400 !important;
}

.borderRadius-10 {
  & .vs__dropdown-toggle, .vue-treeselect__control {
    border-radius: 10px !important;
  }
  border-radius: 10px !important;
}

.buttonColor{
  background-color: #16DBCC !important;
  color: #000000 !important;
  border-color: #16DBCC !important;
  font-weight: 400 !important;
}

.btn-outline-success,
.btn-outline-success:hover,
.btn-outline-success:focus,
.btn-outline-success:active,
.btn-outline-success:not(:disabled):not(.disabled):active {
  color: #0a2f73 !important;
}

.btn-outline-success .feather {
  color: #0a2f73 !important;
}

::v-deep .royalty-report-tabs .nav-pills .nav-link,
::v-deep .royalty-report-tabs .nav-pills .nav-link:hover,
::v-deep .royalty-report-tabs .nav-pills .nav-link:focus {
  color: #003366 !important;
}

::v-deep .royalty-report-tabs .nav-pills .nav-link.active,
::v-deep .royalty-report-tabs .nav-pills .show > .nav-link {
  color: #ffffff !important;
}



</style>
